export const CUSTOMER_PROFILE_FORM_FIELDS: { name: string; label: string }[] = [
    { name: 'customer_code', label: 'Customer Code' },
    { name: 'customer_name', label: 'Customer Name' },
    { name: 'address_1', label: 'Address 1' },
    { name: 'address_2', label: 'Address 2' },
    { name: 'address_3', label: 'Address 3' },
    { name: 'address_4', label: 'Address 4' },
    { name: 'district', label: 'District' },
    { name: 'state', label: 'State' },
    { name: 'postcode', label: 'Postcode' },
    { name: 'area', label: 'Area' },
    { name: 'phone', label: 'Phone' },
    { name: 'email', label: 'Email' },
];
